<section class="container-fluid bg-white">
    <!--- header -->
    <header class="row">
        <div class="col-xl-3 col-12 d-flex align-items-center" [ngClass.sm]="'pt-1'" [ngClass.md]="'pt-1'">
            <img src="../assets/images/logo/nepta.svg" alt="brand-logo" height="28"/>
        </div>
        <div class="col-xl-9 col-12 px-xl-0">
            <app-onboarding-header></app-onboarding-header>
        </div>
    </header>
    <!--- body -->
    <section class="row" id="main-container">
        <div class="col-md-9 col-12 offset-md-3 pt-2 position-relative">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                    <h1>{{"BANK_DATA" | translate}}</h1>
                    <small>{{"INSERT.ADD_IBAN" | translate}}</small>
                </div>
                <div class="col-lg-6 col-md-6 col-12 text-lg-right text-md-right text-left">
                    <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL'|translate" placement="top"
                          class="cursor-pointer text-primary">{{'DONT_KNOW_HOW_TO_DO'|translate}}</span>
                </div>
            </div>
            <div class="row align-items-center py-2 border-bottom">
                <div class="form-group col-12 col-md-7">
                    <label [for]="'name_'">{{"IBAN" | translate}}<sup class="text-danger">*</sup></label>
                    <input class="form-control" type="text" maxlength="30" [(ngModel)]="iban"/>
                    <div class="font-error"
                         *ngIf="showError && (!iban || iban.length != 27)">{{ 'ERRORS.FIELD_REQUEST_IBAN_CHARACTERS' | translate }}</div>
                </div>
            </div>
            <div class="row pr-md-2 pt-2">
                <div class="col-12 d-flex justify-content-end mb-4">
                    <button (click)="save()" type="submit" class="btn btn-primary">{{"NEXT" | translate}}</button>
                </div>
            </div>
        </div>
    </section>
</section>


